"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
var Result;
(function (Result) {
    Result["SUCCESS"] = "SUCCESS";
    Result["FAILURE"] = "FAILURE";
})(Result || (exports.Result = Result = {}));
